var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{style:({ '--color': _vm.color, '--time': _vm.time })},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('span',{key:_vm.data,class:_vm.bold ? 'bold text' : 'text'},[_vm._v(" "+_vm._s(_vm.data)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }